import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/portfolio/Reveal";

export const Stats = () => {
  const { t } = useLang();
  return (
    <section data-testid="stats-bar" className="bg-brand">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10 py-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {t.stats.map((s, i) => {
          const dark = i === 1;
          return (
            <Reveal key={i} delay={i * 0.1}>
              <div className={`rounded-2xl py-6 px-4 text-center ${dark ? "bg-ink" : ""}`}>
                <div className={`font-extrabold tracking-tight text-5xl md:text-6xl ${dark ? "text-white" : "text-ink"}`}>
                  {s.value}
                </div>
                <div className={`font-semibold text-sm md:text-base mt-1 ${dark ? "text-brand" : "text-ink/75"}`}>
                  {s.label}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
